module.exports = __webpack_public_path__ + "media/video_01.a73a8e8a.mp4";